export const TA1 = 1;
export const TA2 = 2;
export const TA3 = 3;
export const IMAIOS = 3;
export const NAV = 4;
